import classNames from 'classnames';
import React, { ButtonHTMLAttributes, FC } from 'react';

export const FormButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ className, ...attrs }) => {
  return <button className={classNames('FormButton btn', className)} {...attrs} />;
};
